(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-faq-collection"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-faq-promo-2"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-faq-promo-3"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-faq-promo-4"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-faq-promo-5"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-faq-promo-6"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-faq-promo"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-faq"] && !Shopify.designMode) return;
  try {
    
$(function() {
  window.initAdvancedFAQ();
})

$(document).on('shopify:section:load', function() {
  window.initAdvancedFAQ();
})

  } catch(e) { console.error(e); }
})();
})();
